<script lang="ts">
  import { useThrelte } from '@threlte/core'
  import { ThreeItemKeys, ThreeItemTypes } from '../../constants/three'
  import useCanvasSelection from '../../hooks/canvas-selection'
  import { assignPrinterIfSelected } from './helpers'
  import useFileQueries from '../../routes/project/hooks/useFileQueries'
  import { sceneMode } from '../../stores/scene-mode'
  import { useMouseEvents } from '../../hooks'

  const { scene, renderer } = useThrelte()
  const { object: canvasSelection } = useCanvasSelection()
  const { assignToPrinterMutation } = useFileQueries()

  const onAssign = (fileId: string, printerId: string) => {
    assignToPrinterMutation.mutate({ fileId, printerId })
  }

  const onRightClick = (e: MouseEvent) => {
    assignPrinterIfSelected(renderer, e, scene, onAssign)
  }

  $effect(() => {
    if (
      ($sceneMode === 'default'
        || $sceneMode === 'translate'
        || $sceneMode === 'rotate')
      && $canvasSelection?.userData[ThreeItemKeys.ITEM_TYPE]
      === ThreeItemTypes.PRINTER
    ) {
      return useMouseEvents({ onRightClick })
    }
  })
</script>
